export default __webpack_public_path__ + "static/media/el11.2b60aafe.png";